import React from "react";
import { Check } from "lucide-react";

const CARDS = [
  { name: "Your Muscle & Strength Program", detail: "Fully customized, rebuilt when needed, delivered in-app with video demos." },
  { name: "Your Nutrition & Macro Plan", detail: "Personalized and adjusted at every check-in. Not a meal plan you'll abandon." },
  { name: "Your Supplement Protocol", detail: "The few supplements worth making staples in your life." },
  { name: "Your Cardiovascular Activity Plan", detail: "Conditioning that builds your engine without stealing from your strength." },
  { name: "Your Gut Health Plan", detail: "Digestion, bloating and absorption addressed. You can't use what you can't absorb." },
  { name: "Your Rest & Recovery Protocol", detail: "Sleep, deloads and stress load, where the results are actually made." },
  { name: "Weekly Check-Ins with Sandra", detail: "Written adjustments back within 24 hours, plus a 1:1 video call every month." },
];

// Same card treatment as the "What's Included" grid on the Full Stack Coaching page.
export const HowFixedCards = () => (
  <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5" data-testid="how-fixed-cards">
    {CARDS.map((c, i) => (
      <div
        key={c.name}
        className={`flex gap-4 rounded-2xl border border-white/10 bg-white/[0.03] p-5 md:p-6 ${
          i === CARDS.length - 1 ? "md:col-span-2" : ""
        }`}
        data-testid={`how-fixed-card-${i + 1}`}
      >
        <span className="shrink-0 mt-0.5 flex h-6 w-6 items-center justify-center rounded-full bg-primary/15 text-primary">
          <Check size={15} strokeWidth={3} />
        </span>
        <span>
          <span className="block text-white font-bold leading-snug">{c.name}</span>
          <span className="mt-1.5 block text-sm text-white/60 leading-relaxed">{c.detail}</span>
        </span>
      </div>
    ))}
  </div>
);
